import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";

interface RewardModalProps {
  isOpen: boolean;
  referralCode: string | undefined;
  toggle: () => void;
}

const RewardModal = ({ isOpen, toggle, referralCode }: RewardModalProps) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const referralLink = `https://app.encharge.io/register?referral=${
    referralCode ?? ""
  }`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000); // Reset after 2s
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} zIndex={1400} size="md">
      <ModalHeader>Rewards</ModalHeader>
      <ModalBody>
        <p>
          Use the link below to refer friends to Encharge. You'll receive 1,000
          extra subscribers when you friends become paying users.
        </p>
        <div className="d-flex align-items-center">
          <Input
            type="text"
            value={referralLink}
            readOnly
            className="me-2 mr-2"
          />
          <Button onClick={copyToClipboard} color="primary">
            {copySuccess ? "Copied!" : "Copy"}
          </Button>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={toggle}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};

export default RewardModal;
